<template>
  <div id="app">
    <b-container class="router-view">
      <div class="content-wrapper d-flex flex-column row-fix">
        <router-view />
      </div>
    </b-container>

    <b-container class="dnb-navbar">
      <b-navbar toggleable="lg" type="dark">
        <b-navbar-brand>
          <b-link to="/">
            {{ $t("nav_message.brand") }}
          </b-link>
        </b-navbar-brand>

        <b-navbar-toggle target="nav_collapse" />

        <b-collapse id="nav_collapse" is-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-item to="/devices/">
              {{ $t("nav_message.devices") }}
            </b-nav-item>

            <b-nav-item to="/bills/">
              {{ $t("nav_message.check") }}
            </b-nav-item>

            <b-nav-item to="/quiz/">
              {{ $t("nav_message.quiz") }}
            </b-nav-item>

            <b-nav-item to="/help/">
              {{ $t("nav_message.help") }}
            </b-nav-item>

            <b-nav-item href="#" @click="switchLocale()">
              {{ displayLocale }}
            </b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </b-container>
  </div>
</template>

<script>
export default {
  computed: {
    displayLocale() {
      let other = 'NL';

      if (this.$i18n.locale === 'nl') {
        other = 'EN';
      }

      return other;
    },
  },
  methods: {
    switchLocale() {
      if (this.$i18n.locale === 'nl') {
        this.$i18n.locale = 'en';
      } else {
        this.$i18n.locale = 'nl';
      }
    },
  },
};
</script>

<style scoped lang="scss">
  // Local styles
  .dnb-navbar.container {
    padding-left: 0;
    padding-right: 0;
    z-index: 10;
    pointer-events: none;
    .navbar {
      // background-color: #322984 ;
      background-color: darken(#322984, 5%) ;
    }
    a, button, li {
      pointer-events: all;
    }
    .navbar-toggler {
      border:0;
    }
    .navbar-toggler:focus {
      outline:0;
    }
    .navbar-brand a {
      font-size: 28px;
      text-decoration: none;
      color: rgba(255,255,255,.5);
      &:hover {
        color: rgba(255,255,255,1);
      }
      @media (max-width: 992px) {
        display: none;
      }
    }
    .navbar-nav {
      font-size: 20px;
      // padding-top: 4px;
      @media (max-width: 992px) {
        height: calc(100vh - 54px);
        padding-top: 102px;
        a {
          font-size: 32px;
          text-align: center;
        }
      }
      @media (max-width: 576px) {
        padding-top: 40px;
      }
    }
  }
  .navbar-dark .navbar-toggler-icon {
    opacity: 0.5;
    &:hover {
      opacity: 1;
    }
  }
  .router-view {
    position: absolute;
    top: 54px;
    left:0;
    bottom: 0;
    right:0;
    z-index: 0;
    background-color: #322984;
    .content-wrapper.row-fix {
      position: relative;
    }
  }
</style>

<style lang="scss">
  // Global styles
  body {
    height: 100vh;
    font-family: 'DNB Fedra Light', Sans-Serif;
    font-variant-numeric: lining-nums;
    color: white;

    p {
      font-family: 'DNB Fedra Light', Sans-Serif;
      font-variant-numeric: lining-nums;
      font-size: 16px;
      line-height: 23px;
      @media (max-width: 575.98px) {
        font-size: 14px;
        line-height: 20px;
      }
    }
    h2 {
      font-family: 'DNB Fedra Book', Sans-Serif;
      font-variant-numeric: lining-nums;
      font-size: 24px;
      line-height: 30px;
      margin-bottom:12px;
      @media (max-width: 575.98px) {
        font-size: 20px;
        line-height: 26px;
      }
    }
    h3 {
      font-family: 'DNB Fedra Book', Sans-Serif;
      font-variant-numeric: lining-nums;
      font-size: 20px;
      line-height: 24px;
      @media (max-width: 575.98px) {
        font-size: 17px;
        line-height: 21px;
      }
    }
    a {
      font-family: 'DNB Fedra Light', Sans-Serif;
      font-variant-numeric: lining-nums;
      color: #9994c2;
      &:hover {
        text-decoration: none;
        &:hover {
          color: rgba(255,255,255,.75);
        }
      }
    }
    strong {
      font-family: 'DNB Fedra Medium', Sans-Serif;
      font-variant-numeric: lining-nums;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue